import React from 'react';

export const ImageButton = (props) => {
    return(
        <button className={props.btnClass} onClick={props.onClick} disabled={props.disabled}>
            <img src={props.image} className={props.imgClass} />
        </button>
    );
}